import { useState } from 'react';

import noop from 'lodash/noop';

import { RadioGroupItem } from './RadioGroupItem';
import { RadioGroupContainer } from './styles';

interface RadioButtonListProps {
  labelList: string[];
  defaultSelectedLabel: string;
  onClick?: (selectedLabel: string) => void;
  ariaLabel: string;
}

export const RadioGroup = ({ labelList, defaultSelectedLabel, onClick = noop, ariaLabel }: RadioButtonListProps) => {
  const [selectedLabel, setSelectedLabel] = useState(defaultSelectedLabel);

  return (
    <RadioGroupContainer role="group" aria-label={ariaLabel}>
      {labelList.map((label, index) => {
        const id = `${label}-radio-${index}`;
        const selectRadioItem = (label: string) => {
          setSelectedLabel(label);
          onClick(label);
        };
        return (
          <RadioGroupItem label={label} selectedLabel={selectedLabel} onRadioClick={selectRadioItem} id={id} key={id} />
        );
      })}
    </RadioGroupContainer>
  );
};
